import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ReactSelect from "react-select";
import { EmployeePerformanceReportUpdate, StaffSpecificPerformanceSavedReport } from "../../Repository/Api";
import { DownloadPerformanceIndex } from "../Common/DownloadPerformanceIndex";
import SubmittedPerformanceIndex from "../Common/SubmittedPerformanceIndex";
import CustomModal from "../CustomModal";
import { errorMsg, successMsg } from "../Toastify";
import { DefaultYearView, YearView } from "../Common/FinancialYear";

const StaffPerformanceSpecificView = () => {
    const { access_token, first_name, department, desingation } = useSelector((state) => state?.auth?.auth);
    const token = access_token;
    const navigate = useNavigate();
    const { id } = useParams()
    const [count, setCount] = useState({});

    const [statusAcceptModel, setStatusAcceptModel] = useState(false);
    const [validation, setValidation] = useState({});

    useEffect(() => {
        getCount();
    }, []);

    const [active, setActive] = useState(0);
    const links = ["Part - A", "Part - B", "Part - C", "Part - D"];
    const showSelected = (index) => {
        setActive(index);
    };

    const [apply, setApply] = useState({
        academic_contributions: {
            non_sponsored_training: 0,
            training_programmes_conducted: 0,
            sponsored_contact_mode_for_coordinator_training: 0,
            sponsored_contact_mode_for_co_coordinator_training: 0,
            skill_development_for_coordinator_training: 0,
            skill_development_for_co_coordinator_training: 0,
            development_of_moocs_offering_swayam_courses_or_nittt_module: 0,
            development_for_minimum_30_min_video: 0,
            resouce_program_in_training_programmes: 0,
            development_of_training_manual: 0,
            coursed_handled_for_pg_phd_programme: 0,
            new_courses_developed_and_offered: 0,
            curriculum_developed_revised_lt_3_lakhs: 0,
            curriculum_developed_revised_3_to_5_lakhs: 0,
            curriculum_developed_revised_5_to_10_lakhs: 0,
            curriculum_developed_revised_10_to_15_lakhs: 0,
            curriculum_developed_revised_gt_15_lakhs: 0,
            aid_training_programmes_lt_3_lakhs: 0,
            aid_training_programmes_3_t0_5_lakhs: 0,
            aid_training_programmes_gt_5_lakhs: 0
        },
        research_contributions: {
            phd_research_guidance: 0,
            post_graduate_thesis_guidance: 0,
            sponsored_research_projects_submitted: 0,
            sponsored_research_projects_lt_5_lakhs: 0,
            sponsored_research_projects_5_to_15_lakhs: 0,
            sponsored_research_projects_gt_15_lakhs: 0,
            consultancy_works_carried_out_lt_3_lakhs: 0,
            consultancy_works_carried_out_3_to_5_lakhs: 0,
            consultancy_works_carried_out_gt_5_lakhs: 0,
            research_publications_in_sci: 0,
            research_publications_in_scopus_indexed: 0,
            research_publications_in_ugc_listed: 0,
            paper_presented_in_international: 0,
            paper_presented_in_national: 0,
            books_international_publisher: 0,
            books_national_publisher: 0,
            book_chapter_international_publisher: 0,
            book_chapter_national_publisher: 0,
            patents_granted: 0,
            patents_filed_international: 0,
            patents_granted_international: 0,
            patents_filed: 0,
            international_awards: 0,
            national_awards: 0,
        },
        institutional_development: {
            administrative_contributions_hod_of_the_committee: 0,
            administrative_contributions_member_of_the_committee: 0,
            infrastructure_development_internal_funding_upto_10_lakhs: 0,
            infrastructure_development_external_funding_upto_5_lakhs: 0,
            research_or_academic_events_international: 0,
            research_or_academic_events_national: 0,
            events_conducted_with_revenue_generation: 0,
            events_conducted_without_revenue_generation: 0,
            new_initiatives_implemented_with_revenue_generation: 0,
            new_initiatives_implemented_without_revenue_generation: 0,
        },
        professional_contributions: {
            resource_person_in_training_programmes: 0,
            training_programmes_attended_international: 0,
            training_programmes_attended_national: 0,
            participation_and_academic_contributions_international: 0,
            participation_and_academic_contributions_national: 0,
            participation_and_academic_contributions_state: 0,
            overseas_visited_for_academic_events: 0,
            overseas_visited_for_part_of_delegation: 0,
            participation_and_contributions_in_pg_examiner: 0,
            participation_and_contributions_in_doctoral_committee: 0,
            participation_and_contributions_in_phd_examiner: 0,
            editor_in_cheif_sci: 0,
            editor_in_cheif_scopus: 0,
            editorial_board_member_sci: 0,
            editorial_board_member_scopus: 0,
            peer_reviewer_sci: 0,
            peer_reviewer_scopus: 0,
            international_academic_assignment: 0,
            national_academic_assignment: 0,
            fellow: 0,
            life_member: 0,
            member: 0,
        },
    });

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const getMonthName = (monthNumber) => {
        return new Intl.DateTimeFormat("en-US", { month: "long" }).format(
            new Date(2022, monthNumber - 1, 1)
        );
    };

    const d = new Date()

    const monthLength = d.getMonth() + 1
    const month = Array.from({ length: monthLength }, (_, index) => {
        const previousMonthValue = (currentMonth - index + 12) % 12 || 12;
        return {
            value: previousMonthValue,
            label: `${getMonthName(previousMonthValue)}`,
        };
    });


    const setNormalData = (e, key) => {
        setApply({ ...apply, [key]: e });
        if (validation[key]) setValidation({ ...validation, [key]: false });
    };

    const getCount = async () => {
        const response = await StaffSpecificPerformanceSavedReport(id, token);
        if (response && response.statusCode === 200) {
            setCount(response?.data);
        } else {
            errorMsg(response.message);
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const Payload = {
            ...apply,
            id: id
        };
        const response = await EmployeePerformanceReportUpdate(Payload, token);
        if (response && response.statusCode === 200) {
            successMsg(response.message);
            setStatusAcceptModel(false);
            navigate(-1);
        } else {
            errorMsg(response.message);
        }
    };

    return (
        <>
            <div className="">
                <section className="top-content-container">
                    <div className="my-4">
                        <div className="row">
                            <div className="col-lg-6">
                                <h6 className="headertext">
                                    {first_name} - {desingation}
                                </h6>
                                <h6 className="subheadertext">{department}</h6>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="row">
                        <div className="">
                            <div className="graphbox">
                                <form>
                                    <div className="row">
                                        <div className="col-lg-8 my-auto">
                                            <h6 className="labeltitle">
                                                <span
                                                    className="arrowicon"
                                                    onClick={() => {
                                                        navigate(-1);
                                                    }}
                                                >
                                                    ← &nbsp;
                                                </span>
                                                Performance Report Status
                                            </h6>
                                        </div>
                                        <div className="col-lg-4 my-auto">
                                            <div>
                                                <label className="labeltext">Selected Year</label>
                                                <input
                                                    className="fieldinput"
                                                    value={DefaultYearView(count?.academic_year)}
                                                    disabled
                                                />
                                            </div>
                                            <small className="validationerror">
                                                {validation?.academic_year?.message
                                                    ? `Year ${validation?.academic_year?.message}`
                                                    : ""}
                                            </small>
                                        </div>
                                        {apply.academic_year === currentYear ? (
                                            <div className="col-lg-4 my-auto">
                                                <div>
                                                    <label className="labeltext">Select Month</label>
                                                    <ReactSelect
                                                        isMulti={false}
                                                        value={apply?.month}
                                                        onChange={(e) => {
                                                            setNormalData(e, "month");
                                                        }}
                                                        options={month}
                                                    />
                                                </div>
                                                <small className="validationerror">
                                                    {validation?.month?.message
                                                        ? `Month ${validation?.month?.message}`
                                                        : ""}
                                                </small>
                                            </div>
                                        ) : (
                                            <div className="col-lg-4 my-auto displaynone">
                                                <input
                                                    type="text"
                                                    placeholder="Enter count"
                                                    className="fieldinput"
                                                    defaultValue={apply?.months ?? 0}
                                                    onChange={(e) => {
                                                        setNormalData(e, "months");
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className="mt-5">
                                        <ul className="searchtopflex">
                                            {links.map((link, index) => {
                                                return (
                                                    <li
                                                        onClick={() => showSelected(index)}
                                                        key={link}
                                                        className={
                                                            active === index
                                                                ? "agenttextactive"
                                                                : "agenttextinactive"
                                                        }
                                                    >
                                                        {link}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                    <SubmittedPerformanceIndex active={active} count={count} />
                                    <div className="text-center my-5">
                                        <button type="submit" className="requestbtn" onClick={(e) => DownloadPerformanceIndex(count, e)}>Download Report</button>
                                    </div>
                                    <CustomModal
                                        open={statusAcceptModel}
                                        onClickOutside={() => {
                                            setStatusAcceptModel(false);
                                        }}
                                    >
                                        <div className="modal-content Modal-View m-auto">
                                            <div className="modalHeader text-center py-2">
                                                <h5 className="font-bold mt-2">Confirmation !</h5>
                                            </div>
                                            <div className="modal-body p-0">
                                                <div className="container">
                                                    <div></div>
                                                    <div>
                                                        <h6 className="confirmmodeltext my-4">
                                                            Are You Sure?
                                                        </h6>
                                                    </div>
                                                    <div>
                                                        <h6 className="confirmmodeltext my-4">
                                                            Once Submitted cannot be revote this !
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-footer border-0">
                                                <div className="my-3">
                                                    <button
                                                        type="button"
                                                        className="btn mx-2 modelclosebtn"
                                                        onClick={() => {
                                                            setStatusAcceptModel(false);
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                                <div>
                                                    <button
                                                        className="btn mx-2 approvebutton"
                                                        onClick={(e) => handleSubmit(e)}
                                                    >
                                                        yes, Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </CustomModal>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default StaffPerformanceSpecificView;
